import withConfig from './Config'
export default withConfig
export { type Config } from './types'
